import * as React from "react"

import { cn } from "@/lib/utils"

function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        "file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground border-input h-10 w-full min-w-0 rounded-lg border-2 bg-background/50 px-4 py-2 text-base shadow-sm transition-all duration-200 outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium",
        "hover:border-primary/30 hover:bg-background/70",
        "focus-visible:border-primary focus-visible:ring-4 focus-visible:ring-primary/10 focus-visible:bg-background",
        "disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50",
        "aria-invalid:ring-4 aria-invalid:ring-destructive/10 aria-invalid:border-destructive",
        className
      )}
      {...props}
    />
  )
}

export { Input }
